var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('aside'),_c('div',{staticClass:"centered"},[(!_vm.hideLoading)?_c('img',{staticClass:"img-loading",attrs:{"src":require("@/assets/loading.gif")}}):_vm._e(),_c('h4',[_vm._v(_vm._s(_vm.loadingMsg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }